<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>理赔单详情</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
          "
          :span="24"
        >
          基本信息
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="150"
            :data="resData.claims.list"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="center"
              prop="claims_id"
              label="理赔批次号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="work_count"
              label="工单数量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="num"
              label="理赔商品数量"
            ></el-table-column>
            <el-table-column align="center" label="理赔类型">
              <template slot-scope="scope">
                {{ scope.row.f_claims_type }}/
                {{ scope.row.claims_type }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="money"
              label="理赔金额"
            ></el-table-column>
            <el-table-column align="center" prop="" label="财务备注">
              <template slot-scope="scope">
                <el-input v-model="form.check_remark" type="textarea" />
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <div v-if="scope.row.check_status == 1">
                  <el-button type="success" @click="check(2)">通过</el-button>
                  <el-button type="danger" @click="check(3)">驳回</el-button>
                </div>
              </template>
              <!--<template slot-scope="scope">-->
              <!--</template>-->
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>

    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
          :span="24"
        >
          <span>商品明细</span>
          <el-button
            style="width: 120px; margin-left: auto"
            type="primary"
            size="mini"
            @click="output"
            >导出</el-button
          >
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="center"
              prop="work_id"
              label="工单ID"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="create_time"
              label="登记时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="goods_lib_origin"
              label="发货地"
            ></el-table-column>
            <el-table-column align="center" label="商品图片">
              <template slot-scope="scope">
                <div
                  v-if="scope.row.imgs.length > 0"
                  style="width: 70px; height: 70px"
                >
                  <img
                    :src="scope.row.imgs[0]"
                    style="width: 100%; height: 100%"
                    @click="showImages(scope.row.imgs)"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              width="150"
              prop="goods_name"
              label="商品名称"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="goods_no"
              label="商品货号"
            ></el-table-column>
            <el-table-column align="center" label="颜色/尺码/件数">
              <template slot-scope="scope">
                {{ scope.row.co_val }}/ {{ scope.row.si_val }}/
                {{ scope.row.goods_number }}
              </template>
            </el-table-column>

            <el-table-column
              align="center"
              prop="no_back_num"
              label="理赔件数"
            ></el-table-column>

            <el-table-column
              align="center"
              prop="refund_goods_money"
              label="商品金额"
            ></el-table-column>

            <el-table-column
              align="center"
              prop="problem_type"
              label="问题类型"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="problem_name"
              label="问题描述"
            ></el-table-column>

            <el-table-column
              align="center"
              prop="service_desc"
              label="客服备注"
            ></el-table-column>

            <el-table-column
              align="center"
              prop="service_order_handle_status"
              label="处理状态"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="money"
              label="商品理赔"
            ></el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>

    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
          "
          :span="24"
        >
          操作记录
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="300"
            :data="resData.log"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column prop="operator_name" label="操作人">
              <template slot-scope="scope">
                <span>{{
                  scope.row.operator_name == 0 ? "" : scope.row.operator_name
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="action_content"
              label="操作记录"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="create_date"
              label="操作时间"
            ></el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
    <preview-image
      :imgs="images"
      :show="showbox"
      @closeBox="closeBox()"
    ></preview-image>
  </div>
</template>

<script>
import PreviewImage from "../../components/PreviewImage.vue";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  components: {
    PreviewImage,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      showbox: false,
      images: [],
      resData: {
        claims: {
          list: [],
        },
      },
      form: {
        claims_id: this.$route.params.id,
        check_remark: "",
      },
      msg: "",
      loading: false,
      tableLoading: false,
      url: "/erp/claims/detail",
      curPage: 1,
      detailcurPage: 1,
      filterFold: false,
      isAll: false,
      claims_id: this.$route.params.id,
      detailVisible: false,
      delVisible: false,
      wave_picking_info_id: 0,
      infoDetail_pages: 0,
      infoDetail: [],
      dialogFormVisible: false,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    check(status) {
      this.$confirm("确定操作?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/erp/claims/check", {
              claims_id: this.claims_id,
              status,
              check_remark: this.form.check_remark,
            })
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message.error(res.data.msg);
              } else if (res.data.code !== 200) {
                this.$message.error(res.data.msg);
              } else {
                this.$message.success(res.data.msg);
                this.fetchData();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    output() {
      this.$http
        .post("/erp/claims/outputDetail", { claims_id: this.claims_id })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        });
    },
    showImages(img) {
      this.showbox = true;
      this.images = img;
    },
    closeBox() {
      this.showbox = false;
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(`${this.url}/claims_id/${this.claims_id}`).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.form.check_remark = res.data.data.claims.list[0].check_remark;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const multipleSelection = [];
      for (const key in val) {
        multipleSelection[key] = {
          id: val[key].id,
        };
      }
      this.form.multipleSelection = JSON.stringify(multipleSelection);
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },

    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },

    trim(str, is_global) {
      let result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (is_global.toLowerCase() == "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/claims/Detail.vue